import React from 'react';
import { IoCloseOutline } from 'react-icons/io5';
import './CategoryBubbles.css';

export function CategoryBubbles({ categories, currentCategoryKeys, setCurrentCategoryKeys }) {
    // Function to toggle the category selection
    const toggleCategory = (categoryKey) => {
        console.log('categoryKey', categoryKey);
        setCurrentCategoryKeys(prevKeys => {
            if (prevKeys.includes(categoryKey)) {
                // Remove category if already selected
                return prevKeys.filter(key => key !== categoryKey);
            } else {
                // Add category if not already selected
                return [...prevKeys, categoryKey];
            }
        });
    };

    // Sort categories based on selection status
    // const sortedCategories = [...categories].sort((a, b) => {
    //     const aSelected = currentCategoryKeys.includes(a.key) ? -1 : 1;
    //     const bSelected = currentCategoryKeys.includes(b.key) ? -1 : 1;
    //     return aSelected - bSelected;
    // });

    return (
        <div className="categoryBubbleContainer">
            {categories.map((category) => (
                <div
                    key={category.key}
                    className={`categoryBubble ${currentCategoryKeys.includes(category.key) ? 'selected' : ''}`}
                    onClick={() => toggleCategory(category.key)}
                >
                    {/* {currentCategoryKeys.includes(category.key) ? <IoCloseOutline size={20} color={'#F2EFF4'} /> : null} */}
                    {category.category}
                </div>
            ))}
        </div>
    );
}
